import { useSearchParams } from 'next/navigation'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'

const expasToDisplaySingleVariant = new Set([
  'ads',
  'bil',
  'con',
  'def1',
  'def2',
  'def3',
  'doo',
  'gue',
  'ide',
  'kel',
  'lad',
  'prez',
  'sho',
  'shof',
  'shp',
  'tro',
])
/**
 * Check url for expa gglp & tro and only display the PZN/packsize in the url on that landing page (PDP)(ticket:cro-5027)
 * Targeting: PDP as entry page, only visitors with expa gglp & tro, responsive.
 */
export const useProductPageShouldHidePackSizeSelectorForExpa = (): boolean => {
  const searchParams = useSearchParams()
  const expaValue = searchParams.get('expa')

  const { tenant } = useGlobalConfigContext()

  // hide the selector for packsizes / packsizes for CBP visitors in IT
  return (
    tenant === TENANT.IT &&
    expaValue !== null &&
    expasToDisplaySingleVariant.has(expaValue)
  )
}
